import React, { useState } from 'react';

function ItemTypeSelectionModal({ inventory, onSelectItemType, onClose }) {
  const [selectedItemTypeId, setSelectedItemTypeId] = useState(
    inventory.default_item_type ? inventory.default_item_type.id : 
    (inventory.item_types && inventory.item_types.length > 0 ? inventory.item_types[0].id : '')
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedItemTypeId) return;
    
    const selectedItemType = inventory.item_types.find(type => 
      type.id == selectedItemTypeId || type.id === parseInt(selectedItemTypeId)
    );
    onSelectItemType(selectedItemType);
  };

  const selectedItemType = inventory.item_types?.find(type => 
    type.id == selectedItemTypeId || type.id === parseInt(selectedItemTypeId)
  );

  return (
    <div className="modal">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <h2>Select Item Type</h2>
        <p>This inventory has multiple item types. Please select which type of item you want to add:</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Item Type *</label>
            <div style={{ 
              border: '1px solid #ddd', 
              borderRadius: '4px', 
              maxHeight: '300px', 
              overflowY: 'auto'
            }}>
              {inventory.item_types && inventory.item_types.map(itemType => (
                <div key={itemType.id} style={{ 
                  padding: '1rem',
                  borderBottom: '1px solid #eee',
                  backgroundColor: selectedItemTypeId == itemType.id ? '#f0f8ff' : 'transparent',
                  cursor: 'pointer'
                }}
                onClick={() => setSelectedItemTypeId(itemType.id)}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <input
                      type="radio"
                      name="itemType"
                      id={`itemtype-${itemType.id}`}
                      value={itemType.id}
                      checked={selectedItemTypeId == itemType.id}
                      onChange={(e) => setSelectedItemTypeId(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label htmlFor={`itemtype-${itemType.id}`} style={{ cursor: 'pointer', fontSize: '1rem', fontWeight: 'bold' }}>
                      {itemType.name}
                      {itemType.is_default && <span style={{ fontSize: '0.8rem', color: '#0066cc', marginLeft: '0.5rem' }}>(Default)</span>}
                    </label>
                  </div>
                  
                  {itemType.description && (
                    <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                      {itemType.description}
                    </div>
                  )}
                  
                  <div style={{ fontSize: '0.8rem', color: '#888' }}>
                    {itemType.fields?.length || 0} fields
                    {itemType.fields && itemType.fields.length > 0 && (
                      <span style={{ marginLeft: '0.5rem' }}>
                        ({itemType.fields.slice(0, 3).map(f => f.name).join(', ')}
                        {itemType.fields.length > 3 && `, +${itemType.fields.length - 3} more`})
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {selectedItemType && (
            <div className="form-group">
              <label>Selected Item Type Preview</label>
              <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '4px', backgroundColor: '#f9f9f9' }}>
                <p><strong>{selectedItemType.name}</strong></p>
                {selectedItemType.description && <p style={{ fontSize: '0.9rem', color: '#666' }}>{selectedItemType.description}</p>}
                {selectedItemType.fields && selectedItemType.fields.length > 0 ? (
                  <div>
                    <p style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>The new item will have these fields:</p>
                    {selectedItemType.fields.map((field, index) => (
                      <div key={index} style={{ fontSize: '0.9rem', marginBottom: '0.25rem' }}>
                        • <strong>{field.name}</strong> ({field.type})
                        {field.required && <span style={{ color: '#e74c3c' }}> *</span>}
                        {field.description && ` - ${field.description}`}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#666' }}>No fields defined for this item type.</p>
                )}
              </div>
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
            <button type="button" className="btn" onClick={onClose}>
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn" 
              disabled={!selectedItemTypeId}
            >
              Continue with {selectedItemType?.name || 'Selected Type'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ItemTypeSelectionModal;